import { Page } from '../../../../../components/page/page';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { StatementsCards } from './statements-cards/statements-cards';
import { StatementsControls } from './statements-controls/statements-controls';
import { StatementsTable } from './statements-table/statements-table';
import s from './statements.module.css';
import { UpdateStatementStatusModal } from './update-statement-status-modal/update-statement-status-modal';
import { useStatements } from './use-statements';

export const Statements = () => {
  const { t, list, viewStyle, updateStatementStatus } = useStatements();

  return (
    <Page className={s.page}>
      <HasAccess service="staff" permissions={['write']}>
        {updateStatementStatus.isOpen && (
          <UpdateStatementStatusModal
            onClose={() => updateStatementStatus.handleCloseModal(['statement'])}
          />
        )}
      </HasAccess>

      <h2 className={s.title}>
        {t('График отпусков и больничных')} ({list?.length})
        <StatementsControls />
      </h2>

      {viewStyle === 'table' ? <StatementsTable /> : <StatementsCards />}
    </Page>
  );
};
